import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useThemeController } from '@chkp/point.core.point-theme';
import PointThemeVars from '../PointThemeVars';
import { PointUtils } from '../../utils/point-ds';
import { Themes } from '../../style/theme-consts';
import * as S from './styled';

const MODE_KEY = 'argos.point-theme-mode';

const readStoredMode = () => {
  try {
    return localStorage.getItem(MODE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
};

const ThemeModeSync = () => {
  const { themeMode } = useThemeController();

  useEffect(() => {
    try {
      localStorage.setItem(MODE_KEY, themeMode);
    } catch {
      /* storage blocked — the mode still applies for this session */
    }
    document.body.dataset.pointTheme = themeMode;
    document.body.classList.toggle(Themes.POINT_DARK, themeMode === 'dark');
    PointUtils.notifyPointDSChange();
    return () => {
      delete document.body.dataset.pointTheme;
      document.body.classList.remove(Themes.POINT_DARK);
      PointUtils.notifyPointDSChange();
    };
  }, [themeMode]);

  return null;
};

/** Wraps the app in Point's provider only under Point, so legacy gets none of its inline tokens.
  PointThemeVars sits inside it so <body> (and the portals that inherit from it) follows the mode. */
const PointThemeRoot = ({ children }) => {
  const isPoint = PointUtils.usePointDS();
  if (!isPoint) return children;

  return (
    <S.Root initialTheme={readStoredMode()}>
      <PointThemeVars />
      <ThemeModeSync />
      {children}
    </S.Root>
  );
};

PointThemeRoot.propTypes = {
  children: PropTypes.node
};

export default PointThemeRoot;
